module.exports = __webpack_public_path__ + "media/images/web/home/specs/spec_networking_1-4d4ecabc91eeda1cdffffe59c8aa6cb2.jpg";